import { LegalEntityForSelectFragment } from 'generated/resources/graphql'

import Filter from 'modules/core/components/Filter'
import { LegalEntitySelector } from 'modules/core/components/LegalEntitySelector'
import i18n from 'modules/core/lib/i18n'

interface LegalEntityFilterProps {
  selected: LegalEntityForSelectFragment[]
  setSelected: (value: LegalEntityForSelectFragment[]) => void
}

const LegalEntityFilter = ({ selected, setSelected }: LegalEntityFilterProps) => {
  return (
    <Filter.EntitySelector
      label={i18n.t('common.legal_entity')}
      value={selected}
      nameAttribute={'legalName'}
      onValueChange={() => {}}
      component={() => (
        <LegalEntitySelector
          alwaysOpen
          hideBorder
          multiple
          width="s400"
          value={selected}
          onChange={(legalEntities) => {
            setSelected(legalEntities)
          }}
          label=""
        />
      )}
    />
  )
}

export default LegalEntityFilter
